export default __webpack_public_path__ + "static/11-4ddf04dff76a8dd249859445c6a12539.jpg";